import {
  Box,
  IconButton,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import { DataGrid, GridToolbarExportContainer } from "@mui/x-data-grid";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DataContext } from ".";
import { departmentData } from "../../data/departmentData";
import ComponentBackdrop from "../../components/backdrop";
import CustomTheme from "../../theme/customTheme";
import { Edit, ViewAgenda, Visibility } from "@mui/icons-material";
import dayjs from "dayjs";
import CustomToolbar from "../../utils/customToolbar";
import { useApiClient } from "../../context/ApiClientContext";
import api from "../../helper/baseApi";

  const Listing = ({ handleShowButton, openEditModal }) => {
  const rows = useContext(DataContext);
  const { apiUrls: { mobileApiUrl } } = useApiClient();
  
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const navigate = useNavigate();

  const onSelectedCheckbox = (id, rows) => {
    let selectedIds = [];

    if (id.type === "include") {
      selectedIds = Array.from(id.ids);
    } else if (id.type === "exclude") {
      const excluded = new Set(id.ids);
      selectedIds = rows
        .filter((row) => !excluded.has(row.id))
        .map((row) => row.id);
    }
    console.log("selectCheckBox:", selectedIds);
    handleShowButton(selectedIds);
  };

  const navigateDetails = (id) => {
    navigate(`/view-team/${id}`);
  }

  const columns = [
    {
      field: "Actions",
      headerName: "Action",
      width: 100,
      type: "actions",
      hideable: false,
      getActions: (params) => [
        <IconButton
          sx={{ color: "#39493F" }}
          onClick={() => navigateDetails(params.row.id)}
        >
          <Tooltip title="View" placement="right">
            <Visibility />
          </Tooltip>
        </IconButton>,
        // <IconButton
        //     key="edit"
        //     sx={{ color: "#39493F" }}
        //     onClick={() => openEditModal(params.row.id)}
        //   >
        //     <Tooltip title="Edit" placement="right">
        //       <Edit />
        //     </Tooltip>
        //   </IconButton>,
      ],
    },
    {
      field: "code",
      headerName: "Code",
      width: 100,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "name",
      headerName: "Team Name",
      width: 200,
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <Box
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
          }}
        >
          {params.value}
        </Box>
      ),
    },
    {
      field: "startDate",
      headerName: "Start Date",
      minWidth: 150,
      type: "date",
      valueGetter: (params) => {
        const value = params;
        return value ? dayjs(value).toDate() : null;

      },
      valueFormatter: (params) => {
        if (!(params instanceof Date) || isNaN(params)) return "";
        return dayjs(params).format("DD-MM-YYYY");
      },
    },
    {
      field: "endDate",
      headerName: "End Date",
      minWidth: 150,
      type: "date",
      valueGetter: (params) => {
        const value = params;
        return value ? dayjs(value).toDate() : null;

      },
      valueFormatter: (params) => {
        if (!(params instanceof Date) || isNaN(params)) return "";
        return dayjs(params).format("DD-MM-YYYY");
      },
    },
    {
      field: "createdByName",
      headerName: "Created By",
      width: 150,
      headerAlign: "left",
      align: "left",
    },
    // {
    //   field: "createdDate",
    //   headerName: "Created Date",
    //   width: 150,
    //   headerAlign: "left",
    //   align: "left",
    // },
  ];

  return (
     <Box
        style={{
          width: "100%",
          height: "77vh",
          overflowY: rows.length > 10 ? "auto" : "visible", // scroll if too many
        }}
      >
      <ComponentBackdrop open={openBackdrop} />
      <DataGrid
        columns={columns}
        rows={rows}
        showToolbar
         slots={{ toolbar: CustomToolbar }}
        pageSizeOptions={[50, 100, { value: 500, label: "500" }]}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 50 },
          },
          sorting: {
            sortModel: [{ field: 'departmentId', sort: 'desc' }],
          },
        }}
        slotProps={{
           toolbar: {
            title: ""
           },
          loadingOverlay: {
            variant: "linear-progress",
            noRowsVariant: "skeleton",
          },
          disableToolbarButton: {
            csvOptions: "true",
            printOptions: "true",
          },
          toolbar: {
            printOptions: { disableToolbarButton: true },
            csvOptions: { disableToolbarButton: true }
          },
        }}
        checkboxSelection
        onRowSelectionModelChange={(id) => {
          onSelectedCheckbox(id, rows);
        }}
        disableRowSelectionOnClick
        localeText={{ noRowsLabel: "No records found" }}
      />
    </Box>
  );
};

export default Listing;
